import { render, staticRenderFns } from "./QingmingLogo.vue?vue&type=template&id=884c5f6e&scoped=true&"
import script from "./QingmingLogo.vue?vue&type=script&lang=ts&"
export * from "./QingmingLogo.vue?vue&type=script&lang=ts&"
import style0 from "./QingmingLogo.vue?vue&type=style&index=0&id=884c5f6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "884c5f6e",
  null
  
)

export default component.exports